<template>
  <section class="hero">
    <div class="hero-body">
      <div class="container">
        <h1 class="title">
          You must be connected to access to this page.
        </h1>
        <div class="buttons has-text-centered">
          <div class="push"><sign-button /></div>
          <b-button tag="router-link" to="/">Go back to home</b-button>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import SignButton from '@/components/SignButton.vue'

export default {
  name: 'please-connect',
  components: {
    SignButton
  }
}
</script>

<style>
.push {
  margin-right: 10px;
}
</style>
